import { CircularProgress } from '@mui/material';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router-dom';
import ErrorPage from '@/pages/admin/ErrorPage';
import AppLayoutCustomer from '@/layouts/AppLayoutCustomer';

export default function AppRootCustomer() {
  const { pathname } = useLocation();

  return (
    <AppLayoutCustomer>
      <Suspense fallback={<CircularProgress />}>
        <ErrorBoundary key={pathname} fallback={<ErrorPage />}>
          <Outlet />
        </ErrorBoundary>
      </Suspense>
    </AppLayoutCustomer>
  );
}
